import { Component, OnInit } from '@angular/core';
import { ValidationError, FormValidator, FormValidationService, ErrorHandlingService } from 'core-lib';
import { ForgotPasswordService } from '../services/forgot-password.service';

@Component({
  selector: 'cli-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  public vm: ForgotPasswordViewModel;
  public validator: FormValidator;

  constructor(private formValidationSvc: FormValidationService,
    private forgotPasswordSvc: ForgotPasswordService,
    private errorHanldingSvc: ErrorHandlingService) {

    this.vm = new ForgotPasswordViewModel();
    this.validator = this.formValidationSvc.getFormValidator(this.vm);
  }

  ngOnInit() {

  }

  public error(fieldName: string): string {
    return this.formValidationSvc.getErrorMessage(this.vm, fieldName);
  }

  validate(vm: ForgotPasswordViewModel): Promise<void> {
    vm.errors = [];

    this.validator.validateRequired('userName', 'Username');
    this.validator.validateRequired('email', 'Email');
    this.validator.validateEmail('email', 'Email');

    if (vm.errors.length > 0) { return Promise.reject('Invalid Input'); }
    return Promise.resolve();
  }

  public submit(): Promise<void> {
    return this.validate(this.vm).then(() => {

      this.vm.isLoading = true;

      return this.forgotPasswordSvc.requestReset(this.vm.userName, this.vm.email).toPromise()
        .then((data: any) => {

          if(data.isSuccess){
            
            this.vm.isSubmitted = true;
            this.vm.errors = [];

          } else {

            this.vm.isSubmitted = false;
            
            this.validator.validateCustom('email', data.errorMessage, ()=>{return true});
          }
         
        },
          (e) => { this.errorHanldingSvc.processHttpError(e); })
        .finally(() => {
          this.vm.isLoading = false;
        });

    },
      (e) => { 

        return Promise.reject(e);
      });
  }

}

export class ForgotPasswordViewModel {
  constructor() {
    this.errors = [];
  }

  public errors: ValidationError[];
  public isLoading: boolean;
  public isOpening: boolean;
  public isSubmitted: boolean;

  public userName: string;
  public email: string;

}